/* eslint-disable eslint-comments/disable-enable-pair */
import DeviceConfig from '@devices/config';
import Props from '../../../types/props/animation';
import { useEffect, useState } from 'react';

export default function withAnimation(Element: React.ElementType) {
  return ({
    animation = '',
    children,
    delay = 0,
    force = false,
    style,
    ...props
  }: Props) => {
    const [animate, setAnimate] = useState<string | React.CSSProperties | null>(
      null
    );

    useEffect(() => {
      setAnimate(animation);
    }, [animation]);

    return (
      <Element
        {...props}
        className={`${
          DeviceConfig.capabilities.disableAnimations
            ? 'disable-animations'
            : ''
        } ${
          typeof animate === 'string' &&
          (!DeviceConfig.capabilities.disableAnimations || force)
            ? animate
            : null
        }`}
        style={{
          ...(typeof animate === 'object' &&
          (!DeviceConfig.capabilities.disableAnimations || force)
            ? animate
            : null),
          ...(delay
            ? {
                transitionDelay: `${delay}s`,
              }
            : {}),
          ...style,
        }}
      >
        {children}
      </Element>
    );
  };
}
